var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticStyle:{"background-color":"#fff"}},[_c('td',{staticClass:"pt-3 pb-3",attrs:{"colspan":_vm.groupColspan + _vm.emptyCellsCount}},[_c(_vm.subcomponent,{tag:"component",attrs:{"parent":_vm.info.parent}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }